module.exports = {
      id: "personas:three-usage",
      viewBox: "0 0 37 44",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#personas:three-usage",
      toString: function () {
        return this.url;
      }
    }